export default __webpack_public_path__ + "static/montacargas-204bf6f4a56604bbfb1e420a33b78daa.png";